<div [class]="{ 'wchfs-radio-checked': ngControl.control.value === value }" class="wchfs-radio-wrapper">
  <div class="wchfs-radio">
    <input type="radio" [name]="name" [value]="value" />
  </div>
  <label [class.text-grey-1]="!disabled" [class.text-grey-4]="disabled" class="wchfs-radio-label text-input-1">
    <ng-content select="wchfs-label"></ng-content>
  </label>
</div>
